import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {PercentStripComponent} from 'app/tool-layer/tools/percent-strip/percent-strip.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [PercentStripComponent],
    entryComponents: [PercentStripComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(PercentStripComponent),
            multi: true,
        },
    ],
})
export class PercentStripModule {}
